"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Partners = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const PartnersCarousel_1 = require("./PartnersCarousel");
const WithStack = (0, app_1.styled)(ui_1.Stack) `
  width: 100%;
`;
function Partners({ text = 'Partners', partners, }) {
    return ((0, jsx_runtime_1.jsxs)(WithStack, Object.assign({ kind: "vertical", spacing: "large" }, { children: [(0, jsx_runtime_1.jsxs)(app_1.Text, Object.assign({ tag: "span", as: "sub-h3" }, { children: [text, ":"] })), (0, jsx_runtime_1.jsx)(PartnersCarousel_1.PartnersCarousel, { partners: partners })] })));
}
exports.Partners = Partners;
